import api from "@/router/api"

export default {
    getAllCompanies({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesCompanies.list(payload)
                .then(response => {
                    resolve(response.data.data)
                    commit('SET_COMPANIES', response.data.data.data)
                })
                .catch(error => {
                    reject({
                        message: 'Ocurrió un problema al obtener las empresas',
                    })
                })
        })
    },
    searchCompanies({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesCompanies.search(payload)
                .then(response => {
                    resolve(response.data.data)
                    commit('SET_COMPANIES', response.data.data.data)
                })
                .catch(error => {
                    reject({
                        message: 'Ocurrió un problema al obtener las empresas',
                    })
                })
        })
    },
    findCompany({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesCompanies.find(payload)
                .then(response => {
                    resolve(response.data.data)
                    commit('SET_COMPANY', response.data.data)
                })
                .catch(error => {
                    reject({
                        message: 'Ocurrió un problema al obtener la empresa',
                    })
                })
        })
    },

    createCompany({commit}, payload){
        commit('CLEAR_VALIDATION')
        return new Promise((resolve, reject) => {
            api.auxiliariesCompanies.create(payload)
                .then(response => {
                    const {data} = response.data
                    commit('SET_COMPANY', response.data.data)
                    resolve(data)
                })
                .catch(error => {
                    const { data, status} = error.response
                    const { message: title } = data

                    if(status === 422){
                        commit('SET_VALIDATION_ERRORS', data.errors)
                    }
                    reject({title, status})
                })
        })
    },
    updateCompany({commit}, payload){
        commit('CLEAR_VALIDATION')
        return new Promise((resolve, reject) => {
            api.auxiliariesCompanies.update(payload)
                .then(response => {
                    const {data} = response.data

                    resolve(data)
                })
                .catch(error => {
                    const { data, status} = error.response
                    const { message: title } = data

                    if(status === 422){
                        commit('SET_VALIDATION_ERRORS', data.errors)
                    }
                    reject({title, status})
                })
        })
    },
    deleteCompany({commit}, payload) {
        return new Promise((resolve, reject) => {
            api.auxiliariesCompanies.delete(payload.id)
                .then(response => {
                    const {data} = response.data

                    resolve(data)
                })
                .catch(() => {
                    reject({
                        message: 'Error al eliminar la empresa',
                    })
                })
        })
    },
}